import {AxiosError} from 'axios';
import {useRouter} from 'next/router';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {useGroupsQuery} from './useGroupsQuery';

export const useDeleteGroupMutation = (groupID: string | number, options?: UseMutationOptions<unknown, AxiosError>) => {
  const {replace} = useRouter();

  const groupsQuery = useGroupsQuery({filter: 'all', query: ''});

  return useMutation<unknown, AxiosError>(() => api.delete(`v2/groups/${groupID}`), {
    ...options,
    onSuccess: (...params) => {
      options?.onSuccess?.(...params);

      groupsQuery.refetch();
      replace('/groups');
    },
  });
};
